export default {
  "lottie": "_lottie_qy2eyt"
};
